import styled from 'styled-components'
import { BLUE_RIBBON_300, BLUE_RIBBON_400, BLUE_RIBBON_700, DARK_VIOLET, PRIMARY, VIVID_PURPLE, WHITE } from '../../styles/colors'
import { GIVONIC, INTER } from '../../styles/fonts'

import ModalBackground from '../../assets/images/LightGradientBackground.png'

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ModalComponent = styled.div`
  max-width: 500px;
  width: calc(100% - 32px);
  margin: 0 16px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  z-index: 1001;
`

export const Background = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  border-radius: 12px;
  padding: 12px 12px;
  background-image: url(${ModalBackground});
  background-size: cover;
  background-position: center;
`

export const CloseButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 14px;
  right: 14px;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0;
`;

export const Title = styled.span`
  font-family: ${GIVONIC.black};
  font-size: 16px;
  color: ${PRIMARY};
  text-align: center;
  padding: 8px 16px 16px 16px;
  margin: 0;
`

export const Description = styled.span`
  font-family: ${INTER.regular};
  font-size: 13px;
  color: ${DARK_VIOLET};
  text-align: center;
  padding: 0 15px;
  margin: -12px 0 12px 0;
  white-space: pre-line;
`

export const ActionButtonContainer = (styled.div as any)<{ $hasNegativeButton: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  ${({ $hasNegativeButton }: { $hasNegativeButton: boolean }) => {
    if (!$hasNegativeButton) {
      return 'margin-bottom: 8px';
    }
    return '';
  }}
`

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 12px;
`

export const HelpboxDescription = styled.p`
  font-family: ${INTER.regular};
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  color: ${BLUE_RIBBON_700};
  margin: 0;
`

export const HelpboxTitle = styled.p`
  font-family: ${INTER.semiBold};
  font-size: 13px;
  font-weight: 600;
  font-style: normal;
  letter-spacing: 0.024px;
  color: ${DARK_VIOLET};
  margin-bottom: 5px;
  margin: 0;
`

export const ExclamationIconContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const HelpboxTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5vh;
`

export const HelpboxContainer = styled.div`
  position: relative;
  border-radius: 12px;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  display: flex;
  margin-bottom: 12px;
  gap: 12px;
  align-items: flex-start;
  background: linear-gradient(135deg, ${WHITE}, #C9ECFF00);

  &:before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border-radius: 12px;
    padding: 1px;
    background: linear-gradient(to right, ${BLUE_RIBBON_300}, ${VIVID_PURPLE});
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }
`;

export const CloseButton = styled.div`
  background-color: rgba(226, 228, 229, 0.3);
  border-radius: 100px;
  padding: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const KYCIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${BLUE_RIBBON_400};
  opacity: 0.2;
  padding: 18px;
  border-radius: 100%;
`
